<template>
  <div class="welfare-content">
    <div class="welfare-title">
      <img
        src="../../assets/yz/newWelfare/welfare_title_banner.png"
        alt=""
        class="banner"
      />
      <div class="get-btn">
        <img
          src="../../assets/yz/newWelfare/welfare_btn_get.png"
          alt=""
          class="animate__animated animate__pulse"
          @click="getNewWelfare"
        />
      </div>
    </div>

    <div class="conpon-info">
      <div class="swiper">
        <div class="swiper-wrapper" ref="slides">
          <img
            v-for="(img, index) in state.images"
            :key="index"
            :src="img.src"
            :alt="img.alt"
            class="swiper-slide"
          />
        </div>
      </div>
    </div>

    <div class="welfare-desc">
      <h3>「新人福利」活动说明</h3>
      <p>
        1.领取规则：每个用户仅限领取 1 次，领券需绑定手机号，券包可在【我的优惠券】查看。
      </p>
      <p>
        2.新人福利优惠券领取后在游戏内充值时抵扣使用，仅支持0.1折及以下版本的游戏使用，在0.1折及以下版本使用时将膨胀百倍。
      </p>
      <p>3.有效期为领取日起15天内有效，请在有效期内使用，过期将作废。</p>
      <p>
        4.请勿使用非正常手段刷取新人福利，一旦发现将取消违规所得并封禁相应账号。
      </p>
      <p>5.平台可能调整活动规则，活动最终解释权归本 App 所有。</p>
    </div>
  </div>
</template>
<script setup>
import "animate.css";
import { ref, onMounted, reactive, nextTick } from "vue";
import "swiper/swiper-bundle.min.js";
import { Swiper, Pagination, Autoplay } from "swiper";
import "swiper/modules/effect-creative/effect-creative.min.css";
import { setToken } from "@/utils/auth";

const state = reactive({
  images: [
    {
      src: require("../../assets/yz/newWelfare/coupon_100.png"),
      alt: "Image 1",
    },
    {
      src: require("../../assets/yz/newWelfare/coupon_51.png"),
      alt: "Image 2",
    },
    {
      src: require("../../assets/yz/newWelfare/coupon_20.png"),
      alt: "Image 3",
    },
    {
      src: require("../../assets/yz/newWelfare/coupon_12.png"),
      alt: "Image 4",
    },
    {
      src: require("../../assets/yz/newWelfare/coupon_8.png"),
      alt: "Image 5",
    },
    {
      src: require("../../assets/yz/newWelfare/coupon_6.png"),
      alt: "Image 6",
    },
    {
      src: require("../../assets/yz/newWelfare/coupon_5.png"),
      alt: "Image 7",
    },
  ],
});

onMounted(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  initSwiper();
  state.uid = getQueryString("uid");
});

var mySwiper = "";
var slides = ref(null);

Swiper.use([Pagination, Autoplay]);
const initSwiper = () => {
  mySwiper = new Swiper(".swiper", {
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    speed: 1000, // 滑动速度，单位毫秒
    freeMode: true,
    slidesPerView: "auto", // 每次展示多个图片
    loop: true,
    allowTouchMove: true,
    initialSlide: 1,
    loop: true,
  });
};

// 领券
import { getNewUserCoupon } from "@/api/yzgame.js";
import { getQueryString } from "../../utils/location";
import { Toast } from "vant";

//领取新人福利优惠券
const getNewWelfare = async () => {
  // 领取新人福利
  getNewUserCoupon({ uid: state.uid }).then((res) => {
    // console.log("领取新人福利返回的数据-------------", res);
    if (res.data.code == 1) {
      Toast("领取成功");
    } else {
      Toast(res.data.msg);
    }
  });
};
</script>
<style scoped>
.welfare-content {
  height: 100vh;
  width: 100vw;
  overflow: auto;
  padding-bottom: 128px;
  background-color: #fff;
}
.welfare-title {
  background-image: url("../../assets/yz/newWelfare/welfare_title_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 998px;
}
.banner {
  width: 100%;
}
.get-btn {
  background-image: url("../../assets/yz/newWelfare/welfare_btn_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 686px;
  height: 500px;
  margin: -46px auto 0;
  position: relative;
}
.get-btn img {
  width: 532px;
  height: 174px;
  position: absolute;
  bottom: 16px;
  left: 78px;
  animation-iteration-count: infinite;
}
.conpon-info {
  width: 686px;
  height: 440px;
  background-image: url("../../assets/yz/newWelfare/conpon_info_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
  padding: 210px 52px 0;
  overflow: hidden;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
}
.swiper {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  overflow: auto;
  touch-action: pan-y pinch-zoom;
}

.conpon-info img {
  /* width: 170px; */
  width: 170px;
  height: 134px;
  margin-right: 20px;
  flex-shrink: 0;
}

.welfare-desc {
  width: 686px;
  height: 866px;
  background: linear-gradient(#fffbd0 10%, #f0feff 30%);
  border-radius: 70px 70px 70px 70px;
  margin: 24px auto 0;
  padding: 70px 48px;
}
.welfare-desc h3 {
  color: #fe4b7a;
  margin-bottom: 48px;
  font-size: 40px;
}
.welfare-desc p {
  font-size: 32px;
  color: #666666;
  margin-bottom: 32px;
}
</style>
